module.exports = __webpack_public_path__ + "static/media/student_mini_icon.834d610c.svg";